import type { AppUrls, FormInput, SearchResponse } from '../types';

export class ApiService {
    constructor(private readonly urls: AppUrls) {}

    async searchByForm(input: FormInput): Promise<SearchResponse> {
        const name = input.name.trim();
        const birthdate = input.birthdate.trim();
        const params = new URLSearchParams();
        params.set('certNo', input.certNo.trim());
        if (name) params.set('name', name);
        if (birthdate) params.set('birthdate', birthdate);
        return this.post(this.urls.search_url, params.toString());
    }

    async lookupByQrId(qrId: string): Promise<SearchResponse> {
        // POST so qrId stays out of the URL — extra query args break the server-side cHash → 404.
        const params = new URLSearchParams();
        params.set('qrId', qrId.trim());
        return this.post(this.urls.qr_lookup_url, params.toString());
    }

    private async post(url: string, body: string): Promise<SearchResponse> {
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
            body,
        });
        return this.parseResponse(response);
    }

    private async parseResponse(response: Response): Promise<SearchResponse> {
        if (!response.ok) {
            return { error: `HTTP ${response.status}` };
        }
        try {
            const data = await response.json();
            // Empty array == no match per controller convention; normalise to {}
            if (Array.isArray(data) && data.length === 0) return {};
            return data;
        } catch {
            return { error: 'Invalid server response' };
        }
    }
}
